import TuneIcon from '@mui/icons-material/Tune';
import { useTheme } from '@mui/material';

export const Studio = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <TuneIcon fontSize={size} sx={{ color: theme.palette.tertiary.main }} />
  );
};
